export default __webpack_public_path__ + "static/media/ic_people_outline_48px.4c881548.svg";